import { EventService } from '../layout/modal/service/event.service';
import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { ModalEventType, ModalModel } from '../layout/modal/model/modal.model';
import { Observable, Observer } from 'rxjs';
import { ModalConfirmComponent } from '../layout/modal/components/modal-confirm/modal-confirm.component';
import { ModalSize } from '../layout/modal/model/modal-configuration.model';

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	constructor(private eventService: EventService,
							private componentFactoryResolver: ComponentFactoryResolver) {}

	/**
	 * Broadcast an event to open a Dialog.
	 * @param modal: DialogModel
	 */
	open(modal: ModalModel): Observable<any> {
		return new Observable((observer: Observer<any>) => {
			modal.observable = observer;
			this.eventService.broadcast({
				name: ModalEventType.OPEN,
				event: modal,
			});
		});
	}

	/**
	 * Open a Confirmation Dialog that return CONFIRM or CANCEL
	 * @param title
	 * @param content
	 */
	customConfirm(
		title: string, message: string, titleIcon: string = null,
		confirmLabel: string = null, confirmClass: string = null
	): Observable<any> {
		return this.open({
			componentFactoryResolver: this.componentFactoryResolver,
			component: ModalConfirmComponent,
			data: {
				confirmLabel: confirmLabel,
				confirmClass: confirmClass
			},
			content: message,
			modalConfiguration: {
				title: title,
				titleIcon: titleIcon,
				modalSize: ModalSize.CONFIRM,
			},
		});
	}

	/**
	 * Open a Confirmation Dialog that return CONFIRM or CANCEL
	 * @param title
	 * @param content
	 */
	confirm(title: string, message: string): Observable<any> {
		return this.open({
			componentFactoryResolver: this.componentFactoryResolver,
			component: ModalConfirmComponent,
			data: null,
			content: message,
			modalConfiguration: {
				title: title,
				modalSize: ModalSize.CONFIRM,
			},
		});
	}
}
